export default "__VITE_ASSET__DGPL$XHe__"